import './App.css';
import config from './config';
import { Container, Jumbotron, Row, Col, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import logo from './aws.png';
import { useEffect, useState} from 'react';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

function App() {
  const [role, setRole] = useState('');
  const [extID, setExtID] = useState('');
  const [successful, setSuccess] = useState(false);
  const [attack, setAttack] = useState('first');
  const [failCounter, setFailCounter] = useState(0);
  const [moreInfo, setInfo] = useState(false);
  const [evenMoreInfo, setMoreInfo] = useState(false);
  const [accountID, setAccountID] = useState('000000000000')





  const Attack = () => {
    if (attack === 'first') {
      return <FirstAttack setSuccess={setSuccess} setRole={setRole} setAttack={setAttack} failCounter={failCounter} setFailCounter={setFailCounter} setAccountID={setAccountID}/>;
    } else if (attack === 'second') {
      return <SecondAttack setAttack={setAttack} role={role} extID={extID} setSuccess={setSuccess} setRole={setRole} setExtID={setExtID} setAccountID={setAccountID}/>
    } else if (attack === 'third'){
      return <ThirdAttack setAttack={setAttack}/>
    }
      else{
      return <FourthAttack setAttack={setAttack} role={role} extID={extID} setSuccess={setSuccess} setRole={setRole} setExtID={setExtID} setAccountID={setAccountID}/>
      }
  }



  return (
    <div className="App">
      <Container>
        <Jumbotron>
          <Row md="8">
            <Col className="logo">
              <div class="vl">
              <h1>On a Guided Tour!</h1>
              
              
                <p align="justify">Scenario: Your Incident Response team has been called in by your client Chocolatey Treats hit by a ransomeware attack. The company has a decent ops team and from previous exercises you know their network perimeter is well secured. They were weaker on ensuring least privilege roles, so you begin with a scan for cross-account access against Chocolaty's main AWS account 362417992831.<br/> You discovered
a cross account access into Chocolatey coming from a SaaS vendor's AWS accountID and discovered
the portal to the right associated with this account. The following wordlist should be helpful
in brute-forcing roles and/or external-ids related to this SaaS provider https://gist.github.com/kbroughton/7787a08042e1d161927af5e2a2af855d.  
                  <br />
                </p>
              
              {(moreInfo || attack === "second"|| attack === "third" || attack === "fourth")? 
              (<p align="justify">You discover an account not known to be among their accounts or well known vendors using Pacu. </p>
              ) : 
              (<br />)
              }
              {(evenMoreInfo || attack === "second" || attack === "third" || attack === "fourth") ? (<p align="justify">Chocolatey ops informs you that they trialed the Super Secure Cloud app a year ago. They went with another option but did not remove/disable the role created.<br/><br/>You test if the AWS account integration is well secured. Unfortunately it is vulnerable. Can you reproduce the attack against Chocolatey?</p>) : (<br />)}
              {(attack === "third") ? (<p align="justify">There is nothing here! Or is there? You remember a helpful tool you found here: https://github.com/WeAreCloudar/s3-account-search. It's a bit broken, so you need to clone it and run the cli.py inside s3_account_search (don't forget to pip install it too!)</p>) : (<p/>)}
              {(attack === "fourth") ? (<p align="justify">Now you have SSC's account ID. What can you do with it?</p>) : (<p/>)}
              
              <img src={logo} alt="Logo" />
              </div>
            </Col>
            <Col md="6" className="attack">
              
                  
                  <Col className="mt-4">
                    <h1>Vendor Portal</h1>
                    <h3>Super Secure Clouds</h3>
                    <Attack setSuccess={setSuccess} setRole={setRole} failCounter={failCounter} setFailCounter={setFailCounter} />
                    {(attack === "second") ? (<p>Remember, this will execute an assume-role call.</p>) : (<p/>) }
                  </Col>
                
              
              {failCounter > 4 ? (<Button id="more-info-button" color="primary" onClick={() => {setInfo(true)}}>More info</Button>) : (<br />)}
              {failCounter > 9 ? (<Button id="even-more-info-button" color="primary" onClick={() => {setMoreInfo(true)}}>Even more info</Button>) : (<br/>) }
            </Col>
          </Row>
        </Jumbotron>
        <Jumbotron id="hidden_jumbotron" hidden className="alternative_jumbotron">
          <Jumbotron className="jumbotron_modified">
            <p className="jumbotron_text">Executing command...</p><p className="jumbotron_text">aws sts assume-role --role-arn arn:aws:iam::{accountID}:role/{role} {extID !== '' ? (<p>--external-id {extID}</p>) : (<a />)} --role-session-name hacking</p>
            {successful ? (<h2 className="jumbotron_text_success">CONNECTION SUCCESSFUL</h2>) : (<h2 className="jumbotron_text_fail">CONNECTION FAILED</h2>)}
            {(attack === "fourth") ? (<p className="jumbotron_text">Role permissions: ListBuckets, GetObject. <br/> 2 Public items inside secrets-scraped-from-customers bucket: image.jpg, flag.txt</p>) : (<br/>)}
          </Jumbotron>
        </Jumbotron>
      </Container>
    </div>
  );
}

export default App;



function FirstAttack({ setSuccess, setRole, setAttack, failCounter, setFailCounter,setAccountID}) {
  return (
    <div>
      <Form>
        <FormGroup>
          <Label for="enterLogin" hidden>Enter login information</Label>
          <br/>
          <Label for="accID" hidden>Account ID</Label>
          <Input className="" type="text" name="accID" id="accID" placeholder="Account ID" />
          <Label for="newRole" hidden>Role name</Label>
          <Input className="" type="text" name="role" id="newRole" placeholder="Role name" />
        </FormGroup>
        <Button onClick={() => { firstAttackLogic({ setSuccess, setRole, failCounter, setFailCounter, setAttack,setAccountID}) }} color="primary" className="ml-1">Next</Button>
      </Form>
    </div>);
}

async function firstAttackLogic({ setSuccess, setRole, failCounter, setFailCounter, setAttack,setAccountID }) {

  const clearJumbotron = () => {
    document.getElementById("hidden_jumbotron").setAttribute("hidden", "true");
  }

  const accountID = document.getElementById("accID").value;
  setAccountID(accountID)

  const role = document.getElementById("newRole").value;
  setRole(role);

  if (!role || role.value === '' || !accountID || accountID.value === '') {
    clearJumbotron();
    return;
  }

  // axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*'
  const result = await axios({ 
    method: 'POST',
    url: `${config.api_base_url}/connect`,
    data: {
      "accountID":accountID,
      "roleARN": role,
    }
  });


  if (result && result.status === 200){
      setSuccess(true);
      document.getElementById("hidden_jumbotron").removeAttribute("hidden");
      setTimeout(() => { clearJumbotron(); setAttack('second'); }, 4000);

  } else if (result && result.status === 206){
      setSuccess(false);
      setFailCounter(failCounter+1)
      document.getElementById("hidden_jumbotron").removeAttribute("hidden");
      setTimeout(() => { clearJumbotron() }, 3000);
  } else {
    alert("Server error")
  }
}


function SecondAttack({ setAttack, setRole, setSuccess,setExtID, setAccountID }) {
  return (
    <div>
      <Form>
        <FormGroup>
          <Label for="enterLogin" hidden>Enter login information</Label>
          <br/>
          <Label for="accID" hidden>Account ID</Label>
          <Input className="" type="text" name="accID" id="accID" placeholder="Account ID" defaultValue='362417992831'/>
          <Label for="newRole" hidden>Role name</Label>
          <Input className="" type="text" name="role" id="newRole" placeholder="Role name" defaultValue="SSC_role"/>
          <Label for="newRole" hidden>External-id</Label>
          <Input disabled className="" defaultValue="IDPD32940xkdlei03" type="text" name="external-id" id="extID"/>
          <p>This account requires an external ID</p>
        </FormGroup>
        <Button onClick={() => {secondAttackLogic({setRole,  setExtID, setSuccess,setAttack, setAccountID }) }} color="primary" className="ml-1">Connect</Button>
        
      </Form>
    </div>);
}

async function secondAttackLogic({setRole, setExtID, setSuccess,setAttack, setAccountID}){

  const clearJumbotron = () => {
    document.getElementById("hidden_jumbotron").setAttribute("hidden", "true");
  }

  const accountID = document.getElementById("accID").value;
  setAccountID(accountID);

  const role = document.getElementById("newRole").value;
  setRole(role); 
  
  const extID = document.getElementById("extID").value;
  setExtID(extID);



  const result = await axios({
    method: 'POST',
    url: `${config.api_base_url}/`,
    data: {
      "accountID":accountID,
      "roleARN": role,
      "external-id": extID
    }
  });

  if (result && result.status === 200) {
      setExtID(result.data.externalid);
      setSuccess(true);
      document.getElementById("hidden_jumbotron").removeAttribute("hidden");
      setTimeout(() => { clearJumbotron(); setAttack('third'); }, 4000);
    }else if (result && result.status === 206) {
      setSuccess(false);
      document.getElementById("hidden_jumbotron").removeAttribute("hidden");
      setTimeout(() => { clearJumbotron() }, 5000);
    }
  else{
    alert("Server error")
    }
}

function ThirdAttack({setAttack}) {
  return (
  <div>
    <Col>
    <img src={'https://secrets-scraped-from-customers.s3.amazonaws.com/image.jpg'} alt='s3'/>
    <Button onClick={()=>{thirdAttackLogic({setAttack})}}>Logout</Button>
    </Col>

  </div>);
}


function thirdAttackLogic({setAttack}){
  confirmAlert({
    title: 'Logout',
    message: 'Are you sure?',
    buttons: [
      {
        label: 'Yes',
        onClick: () => {setAttack('fourth')}
      },
      {
        label: 'No',
        onClick: () => {}
      }
    ]
  });
}




function FourthAttack({ setAttack, setRole, setSuccess,setExtID, setAccountID }) {
  return (
    <div>
      <Form>
        <FormGroup>
          <Label for="enterLogin" hidden>Enter login information</Label>
          <br/>
          <Label for="accID" hidden>Account ID</Label>
          <Input className="" type="text" name="accID" id="accID" placeholder="Account ID"/>
          <Label for="newRole" hidden>Role name</Label>
          <Input className="" type="text" name="role" id="newRole" placeholder="Role name" defaultValue="SSC_role"/>
          <Label for="newRole" hidden>External-id</Label>
          <Input className="" type="text" name="external-id" id="extID" placeholder="External-ID"/>
          <p>This account requires an external ID</p>
        </FormGroup>
        <Button onClick={() => {fourthAttackLogic({setRole,  setExtID, setSuccess,setAttack, setAccountID }) }} color="primary" className="ml-1">Connect</Button>
        
      </Form>
    </div>);
}

async function fourthAttackLogic({setRole, setExtID, setSuccess,setAttack, setAccountID}){

  const clearJumbotron = () => {
    document.getElementById("hidden_jumbotron").setAttribute("hidden", "true");
  }

  const accountID = document.getElementById("accID").value;
  setAccountID(accountID);

  const role = document.getElementById("newRole").value;
  setRole(role); 
  
  const extID = document.getElementById("extID").value;
  setExtID(extID);



  const result = await axios({
    method: 'POST',
    url: `${config.api_base_url}/`,
    data: {
      "accountID":accountID,
      "roleARN": role,
      "external-id": extID
    }
  });

  if (result && result.status === 200) {
      setExtID(result.data.externalid);
      setSuccess(true);
      document.getElementById("hidden_jumbotron").removeAttribute("hidden");
    }else if (result && result.status === 401) {
      setSuccess(false);
      document.getElementById("hidden_jumbotron").removeAttribute("hidden");
      setTimeout(() => { clearJumbotron() }, 5000);
    }
  else{
    alert("Server error")
    }
}

